export const FACEBOOK_PIXEL_ID = window.PRODUCTION
    ? '1510966082448459'
    : '436006366968749';

// They're the same for now
export const SEGMENT_FACEBOOK_PIXEL_ID = window.PRODUCTION
    ? '535379520422681'
    : '535379520422681';

const GOOGLE_RECAPTCHA_SITEKEY_PROD =
    '6LcyQ0gUAAAAAB_6B8kIlvVslzgQz5O4tPLlpPhJ';
const GOOGLE_RECAPTCHA_SITEKEY_TEST =
    '6LchQUgUAAAAAGQ8LxbWt9bSFSV_JKknGA25clqp';
export const GOOGLE_RECAPTCHA_SITEKEY = window.PRODUCTION
    ? GOOGLE_RECAPTCHA_SITEKEY_PROD
    : GOOGLE_RECAPTCHA_SITEKEY_TEST;

const AWS_WAF_API_KEY_PROD =
    'ltP8kgzFa95mLbxlfd5bjohDJCQFm9zi3erLMQ8Kdg01WlibCZ1LFcQAhbW5tfq7Ofq9MoCUXlMCprLZ/R2pMzy8nKJfEJtFWCe1hvF3iswGIgxdDVyVBp6547CZl0L/yhdedNq5jcUL0sZns7XPm/fSnH/lmJjxLHmKz+6iUXkNLyZ/dgyUN2lG57ZhS2E37NmQNoPXc98NaoyWou0xuPCx0M8NUeYOnJlbIPCjvZYLY8KBE/0SOpOCAtKGyRzOmJh629wHGCpM/UgisMx/3ZXSBOTaJxHxkZj+smYPof7KvpHc9wvUZ8ibGDztY2SzQgs0hDcvpD3m9xxqWNV80DAipX9jgllVspcvKn/NfxwVapY8OynsxWEJ3Euco7Yu1Dp2HvLl/5VBjYhVm9WxVOMFkmgHBAkvIiTdqMAoI0D6QjwigXVWSuKJ+jo+X12H3BNoFSR8kQ96gcK7ylLTFzpj4DPAcVrfXPm9iWZ6kK1TZFcmfTSw8kViiBio35eYy1qfyMp56TVvmXpKe6E1quC4ZIydHkl44bgoH/pis199UkeLD2aLP24EPiqfGAPP6FEMc1LE9We91WOM1RFLLw6onfspVehlbguNo/tchEMhdnFAVdchQpAnIJHt+EhDgfDJ8wa9Tx+9C/3eTz0AQ4aC/dZtWZZtGdEpHJejrx0=_0_1';
const AWS_WAF_API_KEY_TEST =
    'FYG57e6GSE1DWNCrfjeYicorhjrsojGNUAvULRtraOkxv+PtjauuKsgeklBXWZwIRYsds5+vOcZm1LNUuV51WcJBkBbO2h7KB4g7eQoFqcuCwTmyX/DtjSARz1Un6De5wOcioBjf4xHpInuywYJ73gBlwhUdQ8tDfwWG59xZXJXCwvo/qJt2ul/tysWCccPYbaUlGSVqNorJ3dqhmhyKPj9P7Fv8pcq6Mpm3L9NFupyhtpLAe6oWKYyaJcddiCYgk+2QVheOEy3Zki8RrPG85byY1trx0hSbdEkg7rHG6HFCadsxbQnD6w22W5qRFACmlgDKtL3K5u/YMSZ0dAnuPYd/dRSsLueNTNQD9O7Jbjk3dGec+2/9JnWPW84XRdrpHXBKL/w7iYI4NCG3WTMT9UxUX5cJRfAr0z5WAuClFkvZRJeFAmLr5IyM30Dlr66jR+bykeP+chmsbSbkGx4mfwZJaDgrjT9m4h57gzV0MIfKe+lc1ffryYjPfdGJjHKBQfcxGMPTMaOTIQPq6t7zn+JhP7J+/cK0gdnc47GuN7cH9MBQ5mUu56rvT5oZ+YzQ0RETllW57vZ/JlGGKpAXqVi5VrrrCM/m9DVEcCD4hPsVYtikGtmZythK1Zfoia9AIZwBA1fMPU6iiIto6Ok9+zDPccK37Ab4T3pOZOk9WaI=_0_1';
export const AWS_WAF_API_KEY = window.PRODUCTION
    ? AWS_WAF_API_KEY_PROD
    : AWS_WAF_API_KEY_TEST;

export const GOOGLE_PLACES_KEY = 'AIzaSyDX7WbIqiOMqqKrEiR4bpnYCx4wRrm76Sc';

const SEGMENT_WRITE_KEY_PROD = 'ux5NZmgjpEKohgChNmF0coryiLDdrY0s';
const SEGMENT_WRITE_KEY_TEST = 'twN816D63ad5WNfbh6datz4layXinj2c';

export const SEGMENT_WRITE_KEY = window.PRODUCTION
    ? SEGMENT_WRITE_KEY_PROD
    : SEGMENT_WRITE_KEY_TEST;

export const INTERCOM_APP_ID = window.PRODUCTION ? 'pffa6bga' : 'e2nmlkv4';
